import type { ItemType } from "types"

export const isFreeItem = (item?: ItemType): boolean =>
  item?.origin === "discount"
